import React from 'react';
import PropTypes from 'prop-types';

CustomerContact.propTypes = {
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
};

function CustomerContact({email, phone, ...props}) {
    return (
        <div>
            <span>{email}</span>
            <br/>
            <span>{phone}</span>
        </div>
    );
}

export default CustomerContact;
